
import { Navigate } from 'react-router-dom';
import SuccessPage from '../pages/Success';
import ErrorPage from '../pages/Error';
import PaymentStatusPage from '../pages/checkout/PaymentStatusPage';

export const checkApiStatus = (pblResponseData: any) => {
  if (pblResponseData) {
    
    if (pblResponseData.payment) {
      const paymentStatus = pblResponseData.payment.status;
      if (paymentStatus === 'PENDING_CAPTURE' ||
        paymentStatus === "CREATED" || paymentStatus === "CAPTURED") {
        return <SuccessPage />;
      }      
    }
  
    if (pblResponseData.status) {
      const httpStatus = pblResponseData.status;

      if (
        httpStatus === 400 ||
        httpStatus === 404 ||
        httpStatus === 500
      ) {
        return <ErrorPage />;
      }
    }
    if (pblResponseData.data && pblResponseData.data.status) {
      const pblStatus = pblResponseData.data.status;

      if (pblStatus === 'PAID') {
        return <SuccessPage />;
      } 
      if (pblStatus === 'EXPIRED') {
        return <ErrorPage />;
      }
      if (pblStatus === "REDIRECTED") {
        return <PaymentStatusPage />;
      }
    }

    if (pblResponseData.error) {
      return <ErrorPage />;
    }

    return <Navigate to={`/${pblResponseData.linkId}`} />
  }
  
  return <Navigate to="/" replace />;
}